
































import Vue, { PropType } from 'vue'
import HelpObject from '@/types/components/HelpObject.interface'
export default Vue.extend({
    props: {
        //  The color used to style components icons
        color: {
            type: String,
            default: 'primary'
        },
        //  The icon displayed to the left of the title
        icon: {
            type: String,
            default: null
        },
        //  Determines if we position at the left instead of center
        left: {
            type: Boolean,
            default: false
        },
        //  Our help dialog that appears next to the title
        help: {
            type: Object as PropType<HelpObject>,
            default: null
        },
        //  The small text displayed beneath the title
        subtitle: {
            type: String,
            default: null
        },
        //   Our help dialog that appears next to the subtitle
        subtitleHelp: {
            type: Boolean,
            default: null
        },
        //  A small icon displayed to the left of the subtitle
        subtitleIcon: {
            type: String,
            default: null
        },
        //  Overrides the title class for sizing
        textClass: {
            type: String,
            default: null
        },
        //  The primary title of the component
        title: {
            type: String,
            default: null
        },
        // Determines if icon appears to start product tour
        tour: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        align(): string {
            //  If left is set, use start
            if (this.left) return 'start'
            return 'center'
        },
        justify(): string {
            //  If left is set, use start
            if (this.left) return 'start'
            return 'center'
        },
        path(): string {
            return this.$route.path
        },
        subtitleClass(): string {
            if (this.$vuetify.breakpoint.mdAndUp) return 'caption'

            return 'tiny'
        },
        titleClass(): string {
            if (this.textClass) return this.textClass

            if (this.$vuetify.breakpoint.xlOnly) return 'title'

            if (this.$vuetify.breakpoint.xsOnly) return 'body-2'

            return 'subtitle-2 font-weight-medium'
        }
    },
    methods: {
        getHelp(help: HelpObject): void {
            help.link ? window.open(help.link, '_blank') : this.popDialog(help)
        },
        popDialog({ title, body, button, embedded }): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: title,
                text: body,
                icon: 'mdi-help-circle',
                buttonLinkText: button?.text,
                buttonLink: button?.link,
                buttonNewTab: true,
                embedded: embedded
            })
        },
        async startProductTour(): Promise<void> {
            const productTour = {
                '/invoices': 170208,
                '/csv/import': 170206,
                '/media': 185426,
                '/templates': 170202
            }[this.path]

            if (!productTour) return

            window.Intercom('update', {
                last_request_at: Number(new Date().getTime()) / 1000
            })

            window.Intercom('startTour', productTour)
        }
    }
})
